"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _licenseTc = require("@/api/master/licenseTc");
// Update with your actual API path
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _licenseTc.defaultLicenseTcData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Name is required',
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: 'Description is required',
        trigger: 'blur'
      }]
    };
  }
  created() {
    if (this.isEdit) {
      const id = this.$route.params.id;
      this.fetchData(+id);
    }
  }
  async fetchData(id) {
    try {
      const data = await (0, _licenseTc.getLicenseTcById)(id);
      console.log('API Response for License TC details:', data);
      Object.keys(this.formData).forEach(key => {
        if (key === 'enabled' && (data[key] === undefined || data[key] === null)) {
          this.$set(this.formData, key, true);
        } else if (data[key] !== undefined) {
          this.$set(this.formData, key, data[key]);
        }
      });
      console.log('Fetched License TC details:', this.formData);
    } catch (error) {
      console.error('Failed to fetch License TC details', error);
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await (0, _licenseTc.updateLicenseTc)(this.formData.id, this.formData);
      } else {
        await (0, _licenseTc.createLicenseTc)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'License TC saved successfully',
        type: 'success'
      });
      this.$router.push({
        path: '/license-tcs/list'
      });
    } catch (error) {
      console.error('Failed to save License TC', error);
    } finally {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LicenseTcDetail'
})], default_1);
var _default = exports.default = default_1;